import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import TimeEntries from './pages/TimeEntries';
import Projects from './pages/Projects';
import Absences from './pages/Absences';
import AdminUsers from './pages/AdminUsers';
import AdminTimeEntries from './pages/AdminTimeEntries';
import AdminExport from './pages/AdminExport';
import ChangePassword from './pages/ChangePassword';
import Reporting from './pages/Reporting';

const ProtectedRoute = ({ children, adminRequired }) => {
  const { user, loading } = useAuth();

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Laden...</div>;
  if (!user) return <Navigate to="/login" />;
  if (adminRequired && user.role !== 'admin') return <Navigate to="/" />;

  return <Layout>{children}</Layout>;
};

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Laden...</div>;

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
      <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/zeiterfassung" element={<ProtectedRoute><TimeEntries /></ProtectedRoute>} />
      <Route path="/projekte" element={<ProtectedRoute><Projects /></ProtectedRoute>} />
      <Route path="/abwesenheiten" element={<ProtectedRoute><Absences /></ProtectedRoute>} />
      <Route path="/auswertung" element={<ProtectedRoute><Reporting /></ProtectedRoute>} />
      <Route path="/passwort" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
      <Route path="/admin/benutzer" element={<ProtectedRoute adminRequired><AdminUsers /></ProtectedRoute>} />
      <Route path="/admin/zeiteintraege" element={<ProtectedRoute adminRequired><AdminTimeEntries /></ProtectedRoute>} />
      <Route path="/admin/export" element={<ProtectedRoute adminRequired><AdminExport /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;
